// Close the small-screen menu after navigation, including same-page anchors.
document.addEventListener('click', (event) => {
  const link = event.target.closest('.asel-mobile-nav a');
  if (link) link.closest('details').open = false;
  document.querySelectorAll('.asel-mobile-nav[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.asel-mobile-nav[open]').forEach((menu) => {
    menu.open = false;
    menu.querySelector('summary').focus();
  });
});
